import Platform from "./platform"

class PlatformCommon extends Platform {

}

export default PlatformCommon